import styled, { CSSProperties } from "styled-components";
import React, { PropsWithChildren } from "react";

export interface IconProps {
  className?: string;
  viewBox: string;
  d: string | string[];
  fillColor?: string;
  style?: CSSProperties;
  $size: number | `${number}px`;
}

const Icon = ({
  className,
  viewBox,
  d,
  fillColor,
  style,
  $size,
  children,
  ...rest
}: PropsWithChildren<IconProps>) => {
  const dItems = d ? (Array.isArray(d) ? d : [d]) : undefined;
  return (
    <StyledIcon
      viewBox={viewBox}
      className={className}
      style={style}
      $size={$size}
      {...rest}
    >
      {dItems?.map((dItem, index) => (
        <path
          key={index}
          fillRule="evenodd"
          clipRule="evenodd"
          d={dItem}
          fill={fillColor}
        />
      ))}
      {children}
    </StyledIcon>
  );
};

Icon.defaultProps = {
  fillColor: "currentColor",
};

export default Icon;

export const StyledIcon = styled.svg.attrs({
  xmlns: "http://www.w3.org/2000/svg",
})<{ $size: number | `${number}px` }>`
  width: ${(p) => p.$size || "1em"};
  height: ${(p) => p.$size || "1em"};
`;
